var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          attrs: {
            cols: _vm.cols,
            "form-context": _vm.formContext,
            icon: "inticon-users",
            title: "Gutachter",
          },
          on: { save: _vm.saveFirmAppraisers },
        },
        [
          _c("csp-desktop-info-card-element", {
            staticClass: "col-12",
            attrs: {
              "allow-appraiser-deselect": _vm.canDeselectAppraisers,
              "form-context": _vm.formContext,
              label: "Gutachter",
              "max-height": 550,
              "open-direction": "auto",
              property: "appraisers",
              type: "appraiserselect",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }